import MappaClienti from './MappaClienti';

export default MappaClienti;